// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pCY7IgXhrgp1C8tficvE{padding:0 20px 32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pCY7IgXhrgp1C8tficvE`
};
export default ___CSS_LOADER_EXPORT___;
